// extracted by mini-css-extract-plugin
export default {"Circle":"Circle_Circle__V4kfF","small":"Circle_small__b4+VT","medium":"Circle_medium__Ezk-c"};